import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { decodeTracks }   from "../components/Share";
import { ShareButtons }   from "../components/ShareButtons";

export function RiffAiResult() {
  const { state } = useLocation();
  const { slug }  = useParams();
  const navigate  = useNavigate();

  /* если пришли через навигацию из /loading — треки уже в state;
     если открываем ссылку напрямую — декодируем slug */
  const [playlist] = React.useState(
    state?.playlist ?? decodeTracks(slug || "")
  );

  /* ошибка, прокинутая из loading */
  if (state?.error) {
    return (
      <div style={{ padding: "4rem", textAlign: "center" }}>
        <h1>Something went wrong.</h1>
        <button onClick={() => navigate("/riffai")}>TRY AGAIN</button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "2rem 1rem" }}>
      <h1 style={{ fontFamily: "Anybody", fontSize: "3rem" }}>
        Your Personal Soundscape
      </h1>

      {playlist.map((t) => (
        <div key={t.spotifyId || t.title} style={{ margin: "2rem 0" }}>
          {t.spotifyId ? (
            <iframe
              title={t.title}
              src={`https://open.spotify.com/embed/track/${t.spotifyId}`}
              width="100%"
              height="152"
              frameBorder="0"
              allow="encrypted-media"
            />
          ) : (
            <p>(Not on Spotify) {t.title} — {t.artist}</p>
          )}

          <p style={{ fontFamily: "Anybody" }}>
            <strong>{t.title}</strong> — {t.artist}<br/>
            {t.reason}
          </p>
        </div>
      ))}

      {/* share + try again в одной линии */}
      <div
        style={{
          margin: "4rem 0",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "1.2rem",
        }}
      >
        <ShareButtons />

        <button
          onClick={() => navigate("/riffai")}
          style={{
            padding: "0.8rem 2.4rem",
            border: "none",
            borderRadius: 30,
            background: "#930707",
            color: "#fff",
            fontFamily: "Anybody",
            fontWeight: 800,
            fontSize: "1.05rem",
            textTransform: "uppercase",
            cursor: "pointer",
            boxShadow: "0 4px 14px rgba(0,0,0,.35)",
            transition: "filter .25s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.filter = "brightness(1.15)")}
          onMouseOut ={(e) => (e.currentTarget.style.filter = "none")}
        >
          TRY AGAIN
        </button>
      </div>
    </div>
  );
}
